// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"12":"component---src-templates-advanced-js","197":"75fc9c18","570":"29107295","869":"styles"}[chunkId] + "-" + {"12":"2e2c8ef7664dbd7638ca","197":"c7951de1e32987c6ec80","570":"1e6a772f1a19904c8007","869":"260d178b2018cdaa7d5c"}[chunkId] + ".js";
};